
import { ListAppraisals } from '../../../fragments/admin/appraisals/ListAppraisals'

export const AdminAppraisals = () =>{
    return (
        <main>
            <ListAppraisals/>
        </main>
    )
}